var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000169537632660926633870000008249991698225037489_);}\r\n\t.st1{fill:#5F6368;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075142924311344467440000001801259169175324072_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_482",
    style: {
      clipPath: "url(#SVGID_00000075142924311344467440000001801259169175324072_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_301",
    className: "st1",
    d: "M9,9H5v2h10V9H9z M10,20c-1.34,0.01-2.67-0.26-3.9-0.79C3.7,18.2,1.8,16.3,0.79,13.9 C0.26,12.67-0.01,11.34,0,10c-0.01-1.34,0.26-2.67,0.79-3.9C1.8,3.7,3.7,1.8,6.1,0.79C7.33,0.26,8.66-0.01,10,0 c1.34-0.01,2.67,0.26,3.9,0.79c2.4,1.01,4.3,2.92,5.31,5.31c0.53,1.23,0.8,2.56,0.79,3.9c0.01,1.34-0.26,2.67-0.79,3.9 c-1.01,2.4-2.92,4.3-5.31,5.31C12.67,19.74,11.34,20.01,10,20 M10,18c2.13,0.04,4.19-0.8,5.68-2.32C17.2,14.19,18.04,12.13,18,10 c0.04-2.13-0.8-4.19-2.32-5.68C14.19,2.8,12.13,1.96,10,2C7.87,1.96,5.81,2.8,4.32,4.32C2.8,5.81,1.96,7.87,2,10 c-0.04,2.13,0.8,4.19,2.32,5.68C5.81,17.2,7.87,18.04,10,18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMinus);
export default __webpack_public_path__ + "static/media/ico_minus.10e54d82a33f652bd8960d0800090afe.svg";
export { ForwardRef as ReactComponent };